"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const products_1 = require("@/store/ducks/products");
const selectors_1 = require("@/store/ducks/products/selectors");
const ToggableInput_1 = __importDefault(require("@/components/ToggableInput"));
function AssociateProductTitle() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isValid, setValidation] = react_1.default.useState(false);
    const value = (0, react_redux_1.useSelector)(selectors_1.productNameToBeAssociatedSelector);
    const onChange = (event) => {
        if (event.target.value === "") {
            setValidation(false);
        }
        else {
            setValidation(true);
        }
        dispatch((0, products_1.setProductNameToBeAssociated)(event.target.value));
    };
    const handleSetValue = () => {
        if (value === "") {
            setValidation(false);
        }
    };
    const errorMessage = react_1.default.useMemo(() => (!isValid && value === "" ? "You must enter a product name" : ""), [isValid, value]);
    const handleToggle = () => {
        dispatch((0, products_1.onShowSavePrompt)());
    };
    return (react_1.default.createElement(ToggableInput_1.default, { required: true, handleToggle: handleToggle, helperText: errorMessage, value: value, onChange: onChange, handleSetValue: handleSetValue, isValid: isValid }));
}
exports.default = AssociateProductTitle;
